import React, { useRef, useState, useEffect } from "react";
import {
  I2cInput,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox, I2cRadioGroup, I2cRadioButton, I2cRadio, I2cFileUpload, I2cAlert
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { verificationToChangePin } from "./stringUtils";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"
import { I2cDataTable } from '@webcomponents/i2cwebcomponents/dist/react';
import { CheckboxRenderer, InputRenderer } from "./CellRenderer";
import {creditPaymentFeature} from "./stringUtils";
const ManagePinCreditPaymentsAndSpendingControl = ({ control, handleValueChanges, methods, errors, appSelectionForProgram,isFormDataUpdated,setIsFormDataUpdated }) => {
  const table = useRef();
  const [gridOptions, setGridOptions] = useState({});
  const [rowDataInitial, setRowDataInitial] = useState(creditPaymentFeature || []);

  useEffect(() => {
      const backendData = methods.getValues('card_management_feature_credit_payments_features_data');
      if (backendData?.length > 0) { 
          setGridOptions({
              columnDefs: [
                  { headerName: 'Feature', field: 'feature', cellRenderer: CheckboxRenderer },
                  { headerName: 'Custom Menu Name', field: 'alternativeMethod', cellRenderer: InputRenderer }
              ],
              rowSelection: 'single',
              rowData: backendData, // Use data from the backend
              suppressMoveWhenRowDragging: true,
              context: { methods, handleValueChanges }
          });
      } else { 
          setGridOptions({
              columnDefs: [
                  { headerName: 'Feature', field: 'feature', cellRenderer: CheckboxRenderer },
                  { headerName: 'Custom Menu Name', field: 'alternativeMethod', cellRenderer: InputRenderer }
              ],
              rowSelection: 'single',
              rowData: rowDataInitial, // Fallback to initial data
              suppressMoveWhenRowDragging: true,
              context: { methods, handleValueChanges }
          });
      }
      // Ensure grid API updates
      const api = table?.current?.getGridApi();
      if (api) {
          api.setRowData && api.setRowData(backendData?.length > 0 ? backendData : rowDataInitial);
      }
  }, [isFormDataUpdated, methods.watch('card_management_feature_credit_payments_features_data')]);
  

  const handleCheckboxChange = (event, fieldName) => {
    const SelectedNetworkValue = event;
    let updatedSelectedNetworks = [
      ...(methods.getValues(fieldName) ?? []),
    ];
    if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
      updatedSelectedNetworks = updatedSelectedNetworks.filter(
        (card) => card !== SelectedNetworkValue,
      );
    } else {
      updatedSelectedNetworks.push(SelectedNetworkValue);
    }
    methods.setValue(fieldName, updatedSelectedNetworks);
    methods.trigger();
    handleValueChanges();
  };

  return (
    <>
      <div i2c-grid="grid gap-md" className="section-space">
        <div i2c-grid="12">
          <div className="sub-heading">
            <span className="productIconFlex">
              <span slot="label" className="organize-tooltip">
                Manage PIN
              </span>
              <AppSelectionIcons
                appSelectionForProgram={appSelectionForProgram}
                mobileLink="https://example.com/mobile-app-a"
                webLink="https://example.com/web-app-a"
              />
            </span>
          </div>
        </div>
        <div i2c-grid="12">
          <div className="single-field-wrapper">
            <Controller
              name="card_management_feature_manage_pin_feature_app_enable"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  label="Please confirm if you would like to enable this feature on the application."
                  {...field}
                  name="card_management_feature_manage_pin_feature_app_enable"
                  onI2cChange={(e) => {
                    field.onChange(e);
                    if(e.target.value === "No"){
                      methods.setValue("card_management_feature_manage_pin_feature_app_enable_custom","")
                      methods.setValue("card_management_feature_manage_pin_feature_required_for",[])
                      methods.setValue("card_management_feature_manage_pin_info_verification_for_change_pin",[])
                      methods.setValue("card_management_feature_manage_pin_enable_captcha","")
                    }
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {["Yes", "No"].map((bc, index) => (
                    <I2cRadioButton
                      key={index}
                      checked={
                        methods.watch("card_management_feature_manage_pin_feature_app_enable") === bc
                      }
                      value={bc}
                    >
                      {bc}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
            <ErrorMessage
              show={
                errors.card_management_feature_manage_pin_feature_app_enable &&
                  methods.formState.touchedFields.card_management_feature_manage_pin_feature_app_enable
                  ? true
                  : false
              }
              message={errors.card_management_feature_manage_pin_feature_app_enable?.message ?? "Invalid input"}
            />
          </div>
        </div>
        {
          methods.watch("card_management_feature_manage_pin_feature_app_enable") === "Yes" && (
            <>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_manage_pin_feature_app_enable_custom"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        label="Enter Custom Name"
                        placeholder="Leave blank for default name"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        name={"card_management_feature_manage_pin_feature_app_enable_custom"}

                      >
                      </I2cInput>
                    )}
                  />
                </div>
              </div>
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  This feature is required for:
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_manage_pin_feature_required_for"
                    control={control}
                    render={({ field }) => (
                      <>
                        <I2cCheckboxGroup
                          {...field}
                          className="centeredCheckbox checkbox-margin"
                        >
                          <div i2c-grid="grid gap-sm">
                            {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={card}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("card_management_feature_manage_pin_feature_required_for")
                                  .includes(card)}
                                onI2cCheckboxClicked={(e) => {
                                  handleCheckboxChange(card, "card_management_feature_manage_pin_feature_required_for");
                                }}
                              >

                                <I2cCheckbox
                                  slot="prefix"
                                  name="card_management_feature_manage_pin_feature_required_for"
                                  filled
                                  value={card}
                                  label=""
                                  ignoreTab
                                  checked={methods
                                    .watch("card_management_feature_manage_pin_feature_required_for")
                                    .includes(card)}
                                  className="customCheckbox"
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cCheckboxGroup>
                        <ErrorMessage
                          show={
                            errors.card_management_feature_manage_pin_feature_required_for &&
                              methods.formState.touchedFields.card_management_feature_manage_pin_feature_required_for
                              ? true
                              : false
                          }
                          message={
                            errors.card_management_feature_manage_pin_feature_required_for?.message ?? "Invalid input"
                          }
                        />
                      </>
                    )}
                  />
                </div>
              </div>

              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  Please select the fields that cardholders must verify to change the PIN.
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_manage_pin_info_verification_for_change_pin"
                    control={control}
                    render={({ field }) => (
                      <>
                        <I2cCheckboxGroup
                          {...field}
                          className="centeredCheckbox checkbox-margin"
                        >
                          <div i2c-grid="grid gap-sm">
                            {verificationToChangePin.map((card, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="4@md"
                                variant="receipt"
                                label={card}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("card_management_feature_manage_pin_info_verification_for_change_pin")
                                  .includes(card)}
                                onI2cCheckboxClicked={(e) => {
                                  handleCheckboxChange(card, "card_management_feature_manage_pin_info_verification_for_change_pin");
                                }}
                              >

                                <I2cCheckbox
                                  slot="prefix"
                                  name="card_management_feature_manage_pin_info_verification_for_change_pin"
                                  filled
                                  value={card}
                                  label=""
                                  ignoreTab
                                  checked={methods
                                    .watch("card_management_feature_manage_pin_info_verification_for_change_pin")
                                    .includes(card)}
                                  className="customCheckbox"
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cCheckboxGroup>
                        <ErrorMessage
                          show={
                            errors.card_management_feature_manage_pin_info_verification_for_change_pin &&
                              methods.formState.touchedFields.card_management_feature_manage_pin_info_verification_for_change_pin
                              ? true
                              : false
                          }
                          message={
                            errors.card_management_feature_manage_pin_info_verification_for_change_pin?.message ?? "Invalid input"
                          }
                        />
                      </>
                    )}
                  />
                </div>
              </div>
              <div i2c-grid="12">
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_manage_pin_enable_captcha"
                    control={control}
                    render={({ field }) => (
                      <I2cRadioGroup
                        label="Enable Captcha for these fields?"
                        {...field}
                        name="card_management_feature_manage_pin_enable_captcha"
                        onI2cChange={(e) => {
                          field.onChange(e);
                          methods.trigger();
                          handleValueChanges();
                        }}
                      >
                        {["Yes", "No"].map((bc, index) => (
                          <I2cRadioButton
                            key={index}
                            checked={
                              methods.watch("card_management_feature_manage_pin_enable_captcha") === bc
                            }
                            value={bc}
                          >
                            {bc}
                          </I2cRadioButton>
                        ))}
                      </I2cRadioGroup>
                    )}
                  />
                  <ErrorMessage
                    show={
                      errors.card_management_feature_manage_pin_enable_captcha &&
                        methods.formState.touchedFields.card_management_feature_manage_pin_enable_captcha
                        ? true
                        : false
                    }
                    message={errors.card_management_feature_manage_pin_enable_captcha?.message ?? "Invalid input"}
                  />
                </div>
              </div>
            </>
          )
        }
      </div>
      <div i2c-grid="grid gap-md" className="section-space">
        <div i2c-grid="12">
          <div className="sub-heading">
            <span className="productIconFlex">
              <span slot="label" className="organize-tooltip">
                Credit Payments
              </span>
              <AppSelectionIcons
                appSelectionForProgram={appSelectionForProgram}
                mobileLink="https://example.com/mobile-app-a"
                webLink="https://example.com/web-app-a"
              />
            </span>
          </div>
        </div>
        <div i2c-grid="12">
          <div className="single-field-wrapper">
            <Controller
              name="card_management_feature_credit_payments_feature_app_enable"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  label="Please confirm if you would like to enable this feature on the application."
                  {...field}
                  name="card_management_feature_credit_payments_feature_app_enable"
                  onI2cChange={(e) => {
                    field.onChange(e);
                    if(e.target.value === "No"){
                      methods.setValue("card_management_feature_credit_payments_feature_app_enable_custom","")
                      methods.setValue("card_management_feature_credit_payments_feature_required_for",[])
                      methods.setValue("card_management_feature_credit_payments_features_data",creditPaymentFeature);
                    }
                    methods.trigger();
                    handleValueChanges();
                    methods.setValue("card_management_feature_credit_payments_features_data",creditPaymentFeature);
                    setIsFormDataUpdated(prev => !prev);
                  }}
                >
                  {["Yes", "No"].map((bc, index) => (
                    <I2cRadioButton
                      key={index}
                      checked={
                        methods.watch("card_management_feature_credit_payments_feature_app_enable") === bc
                      }
                      value={bc}
                    >
                      {bc}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
            <ErrorMessage
              show={
                errors.card_management_feature_credit_payments_feature_app_enable &&
                  methods.formState.touchedFields.card_management_feature_credit_payments_feature_app_enable
                  ? true
                  : false
              }
              message={errors.card_management_feature_credit_payments_feature_app_enable?.message ?? "Invalid input"}
            />
          </div>
        </div>
        {
          methods.watch("card_management_feature_credit_payments_feature_app_enable") === "Yes" && (
            <>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_credit_payments_feature_app_enable_custom"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        label="Enter Custom Name"
                        placeholder="Leave blank for default name"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        name={"card_management_feature_credit_payments_feature_app_enable_custom"}

                      >
                      </I2cInput>
                    )}
                  />
                </div>
              </div>
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  This feature is required for:
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_credit_payments_feature_required_for"
                    control={control}
                    render={({ field }) => (
                      <>
                        <I2cCheckboxGroup
                          {...field}
                          className="centeredCheckbox checkbox-margin"
                        >
                          <div i2c-grid="grid gap-sm">
                            {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={card}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("card_management_feature_credit_payments_feature_required_for")
                                  .includes(card)}
                                onI2cCheckboxClicked={(e) => {
                                  handleCheckboxChange(card, "card_management_feature_credit_payments_feature_required_for");
                                }}
                              >

                                <I2cCheckbox
                                  slot="prefix"
                                  name="card_management_feature_credit_payments_feature_required_for"
                                  filled
                                  value={card}
                                  label=""
                                  ignoreTab
                                  checked={methods
                                    .watch("card_management_feature_credit_payments_feature_required_for")
                                    .includes(card)}
                                  className="customCheckbox"
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cCheckboxGroup>
                        <ErrorMessage
                          show={
                            errors.card_management_feature_credit_payments_feature_required_for &&
                              methods.formState.touchedFields.card_management_feature_credit_payments_feature_required_for
                              ? true
                              : false
                          }
                          message={
                            errors.card_management_feature_credit_payments_feature_required_for?.message ?? "Invalid input"
                          }
                        />
                      </>
                    )}
                  />
                </div>
              </div>
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  If Yes, the following features will be displayed. You can customize their names.
                </div>
                <Controller
                  name="card_management_feature_credit_payments_features_data"
                  control={control}
                  render={({ field }) => (
                    <I2cDataTable
                      id="dataTable1"
                      ref={table}
                      gridOptionInput={gridOptions}
                      notFound={[
                        {
                          description:
                            'No data available. Please add some features or refresh the page.',
                          type: 'noData',
                          icon: 'outline-info-circle',
                          primaryBtn: `<i2c-button variant="primary" size='large'>Reload</i2c-button>`,
                        },
                      ]}
                    ></I2cDataTable>
                  )}
                />
              </div>
            </>
          )
        }
      </div>
      <div i2c-grid="grid gap-md" className="section-space">
        <div i2c-grid="12">
          <div className="sub-heading">
            <span className="productIconFlex">
              <span slot="label" className="organize-tooltip">
                Spending Controls
              </span>
              <AppSelectionIcons
                appSelectionForProgram={appSelectionForProgram}
                mobileLink="https://example.com/mobile-app-a"
                webLink="https://example.com/web-app-a"
              />
            </span>
          </div>
        </div>
        <div i2c-grid="12">
          <div className="custom-label mb-8">
            This feature is required for:
          </div>
          <div className="single-field-wrapper">
            <Controller
              name="card_management_feature_spending_controls_feature_required_for"
              control={control}
              render={({ field }) => (
                <>
                  <I2cCheckboxGroup
                    {...field}
                    className="centeredCheckbox checkbox-margin"
                  >
                    <div i2c-grid="grid gap-sm">
                      {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="6@md"
                          variant="receipt"
                          label={card}
                          sublabel=""
                          value=""
                          type="checkbox"
                          checked={methods
                            .watch("card_management_feature_spending_controls_feature_required_for")
                            .includes(card)}
                          onI2cCheckboxClicked={(e) => {
                            handleCheckboxChange(card, "card_management_feature_spending_controls_feature_required_for");
                          }}
                        >

                          <I2cCheckbox
                            slot="prefix"
                            name="card_management_feature_spending_controls_feature_required_for"
                            filled
                            value={card}
                            label=""
                            ignoreTab
                            checked={methods
                              .watch("card_management_feature_spending_controls_feature_required_for")
                              .includes(card)}
                            className="customCheckbox"
                          ></I2cCheckbox>
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cCheckboxGroup>
                  <ErrorMessage
                    show={
                      errors.card_management_feature_spending_controls_feature_required_for &&
                        methods.formState.touchedFields.card_management_feature_spending_controls_feature_required_for
                        ? true
                        : false
                    }
                    message={
                      errors.card_management_feature_spending_controls_feature_required_for?.message ?? "Invalid input"
                    }
                  />
                </>
              )}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ManagePinCreditPaymentsAndSpendingControl;
